import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';

import { examResults, examStatusEnu } from '@/pages/dashboard/constants'

import './style.css'

import TimelineSection from '@/pages/timeline/sections/timeline'
import CourseCard from '@/pages/timeline/sections/courseCard'
import ExamUnLockCardMain from '@/pages/timeline/sections/examUnLockCard'
import Loader from '@/pages/timeline/loader/index'

export default function TimelineMainView(props: any) {
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);

    const unlockedORFailedEmu = {
        unlocked: "unlocked",
        failed: "failed",
    }

    const isExamUnLockCardMain = (timelineDetails_: any) => {
        if (timelineDetails_) {
            if (timelineDetails_.examStatus === examStatusEnu.unlocked) {
                // return unlockedORFailedEmu.failed // testing
                return unlockedORFailedEmu.unlocked
            }
            if (timelineDetails_.resultDetails && timelineDetails_.resultDetails.result
                && timelineDetails_.resultDetails.result === examResults.failed) {
                return unlockedORFailedEmu.failed
            }
        }
        return ""

    }

    return (
        <div className="timelineMainView">
            {props.isLoading ? (
            // {true ? ( // testing
                <Loader />
            ) : (
                <>
                    <div className="timelineCon">
                        <TimelineSection />
                    </div>

                    {/* {console.log(timelineDetails)} */}

                    <div className='courseCardConMain'>
                        <div className="courseCardCon" >
                            <CourseCard />
                        </div>


                        {isExamUnLockCardMain(timelineDetails) !== "" &&
                            <ExamUnLockCardMain
                                unlockedORFailedEmu={unlockedORFailedEmu}
                                isExamUnLockCardMain={isExamUnLockCardMain}
                            />
                        }
                    </div>
                </>
            )}
        </div>
    );
}
